export const integrations = {
  statuses: {
    connected: 'Подключен'
  },
  timepicker: 'Часы и минуты',
  menu: {
    title: 'Интеграции',
    v1: 'Список',
    settings: 'Настройки'
  },
  breadcrumb: {
    title: 'Интеграции',
    settings: {
      index: 'Настройки CRM'
    },
    auth: {
      index: 'Авторизация'
    },
    users: {
      index: 'Пользователи CRM'
    },
    cases: {
      index: 'Сценарии интеграции'
    },
    numbers: {
      index: 'Номера'
    }
  },
  tabs: {
    auth: 'Авторизация',
    cases: 'Сценарии интеграции',
    users: 'Пользователи',
    numbers: 'Номера'
  },
  button: {
    sync_users: 'Синхронизировать пользователей'
  },
  modal: {
    edit: 'Редактировать пользователя'
  },
  users_status_default: 'Конфигурируется. Звонки недоступны',
  users_status: {
    enabled: 'Звонки доступны',
    disabled: 'Выключен. Звонки недоступны'
  },
  page: {
    amo_info: 'Онлайн CRM система. Управление клиентами в современной облачной CRM — amoCRM.',
    kommo_info: 'Kommo - CRM система агрегирующая все каналы связи в одном месте.',
    connect: 'Подключен как:',
    tooltip: {
      other_integration: 'У вас уже подключена другая интеграция.'
    },
    button: {
      connect: 'Подключить',
      loading: 'Загрузка...',
      settings: 'Настройки',
      not_connected: 'Виджет CRM не подключен'
    },
    no_integration: 'Интеграции отсутствуют'
  },
  users_table: {
    tech_status: 'Технический статус',
    amo_name: 'Имя в CRM',
    amo_login: 'Логин в CRM',
    amo_id: 'ID в CRM',
    sip_account: 'Данные SIP-аккаунта',
    sip_password: 'Пароль SIP-аккаунта',
    caller_id: 'Caller ID',
    inner_number: 'Номер для входящих',
    queue_name: 'Состоит в очереди',
    queue: 'Очередь'
  },
  settings: {
    request_info1: 'Мы получили вашу заявку на подключение интеграции с CRM!',
    request_info2:
      'Технические специалисты уже настраивают для вас входящую и исходящую линии. Для полноценного использования телефонии нужно выбрать и подключить виртуальный номер. В ближайшее время мы свяжемся с вами для этого.',
    account: {
      title: 'Аккаунт',
      description: '',
      settings: {
        main: {
          title: 'Основное',
          description: '',
          children: {
            domain: {
              title: 'Домен',
              description: 'Домен копии CRM, которая была подключена к текущему аккаунту Zorra'
            },
            amo_login: {
              title: 'Логин',
              description: 'Логин аккаунта CRM, который был подключен к текущему аккаунту Zorra'
            },
            status: {
              title: 'Статус',
              description: ''
            },
            integration: {
              title: 'Интеграция'
            }
          }
        }
      }
    },
    integration_scenarios: {
      create_deal: 'Создавать сделку',
      create_task: 'Создавать задачу',
      create_contact: 'Создавать контакт',
      create_note: 'Создавать заметку',
      tooltip_contact: 'В CRM будет создан контакт с номером звонящего клиента.',
      tooltip_deal2: 'В CRM будет создана сделка с номером звонящего клиента.',
      create_deal_unsorted: 'Создавать сделку в "Неразобранное"',
      tooltip_deal_unsorted:
        'В CRM будет создана сделка с номером звонящего клиента на этапе "Неразобранное".',
      tooltip_task:
        'Если Ваш сотрудник не ответил на звонок, то будет создана задача с пропущенным номером.',
      tooltip_time: 'Задайте срок исполнения задачи в часах и минутах. ',

      tooltip_deal:
        'Если контакт существует и у него нет открытых сделок будет создана новая сделка.',

      tooltip_deal3: 'В CRM будет создана сделка с набранным номером телефона.',
      tooltip_note:
        'При исходящих звонках, если абонент не ответил, будет создана заметка: "Не дозвонились до +71234567890".',
      tooltip_outgoing_contact: 'В CRM будет создан контакт с набранным номером телефона.',
      open_contact: 'Открывать контакт',
      tooltip_open_contact:
        'При входящем звонке с любого номера в новой вкладке будет открываться карточка контакта.',
      incoming: {
        title: 'Входящие звонки',
        known: 'С известного номера',
        unknown: 'С неизвестного номера',
        missed: 'Пропущенные звонки',
        deadline_task: 'Срок исполнения задачи',
        any_call: 'Любой звонок'
      },
      outgoing: {
        title: 'Исходящие звонки',
        known: 'На известный номер',
        unknown: 'На неизвестный номер',
        not_answered: 'Звонки без ответа'
      }
    },
    users: {
      title: 'Пользователи',
      description: '',
      settings: []
    },
    webhooks: {
      title: 'Вебхуки',
      description: '',
      settings: []
    },
    additional: {
      title: 'Доп. настройки',
      description: '',
      settings: []
    }
  }
};
